import { values } from 'ramda'

import { BootstrapHook } from '@surglogs-app/types'

export const boot = (
  hooks: { [name: string]: BootstrapHook },
  ...args: Parameters<BootstrapHook>
) => {
  values(hooks).forEach((hook) => {
    hook(...args)
  })
}
